import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("filter", { id: "a" }, [
        _createElementVNode("feColorMatrix", {
          in: "SourceGraphic",
          values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        })
      ])
    ], -1),
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      filter: "url(#a)",
      transform: "translate(-2 -2)"
    }, [
      _createElementVNode("path", {
        fill: "#1A1A1A",
        d: "M10.825 2h2.349c1.675.004 2.06.019 2.949.06 1.064.048 1.791.217 2.427.464a4.9 4.9 0 0 1 1.772 1.153 4.9 4.9 0 0 1 1.153 1.772c.247.636.416 1.363.465 2.427.047 1.031.06 1.384.06 3.86v.527c0 2.476-.013 2.829-.06 3.86-.049 1.064-.218 1.791-.465 2.427a4.9 4.9 0 0 1-1.153 1.772 4.9 4.9 0 0 1-1.772 1.153c-.636.247-1.363.416-2.427.465-1.031.047-1.384.06-3.86.06h-.527c-2.476 0-2.829-.013-3.86-.06-1.064-.049-1.791-.218-2.427-.465a4.9 4.9 0 0 1-1.772-1.153 4.9 4.9 0 0 1-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.04-.89-.055-1.274-.059-2.95v-2.348c.004-1.675.019-2.06.06-2.949.048-1.064.217-1.791.464-2.427a4.9 4.9 0 0 1 1.153-1.772A4.9 4.9 0 0 1 5.45 2.524c.636-.247 1.363-.416 2.427-.465.89-.04 1.274-.055 2.95-.059h2.348zm1.908 1.801h-1.467c-2.007.002-2.359.015-3.308.058-.975.045-1.504.208-1.857.344-.466.182-.8.399-1.15.749s-.566.683-.748 1.15c-.136.352-.3.881-.344 1.856-.043.95-.056 1.3-.058 3.308v1.467c.002 2.007.015 2.358.058 3.308.045.975.208 1.504.344 1.857.182.466.399.8.749 1.15s.683.566 1.15.747c.352.137.881.3 1.856.345 1.055.048 1.371.058 4.042.058s2.986-.01 4.04-.058c.976-.045 1.505-.208 1.858-.345.466-.18.8-.398 1.15-.748s.566-.683.747-1.15c.137-.352.3-.881.345-1.856.048-1.055.058-1.371.058-4.041s-.01-2.987-.058-4.042c-.045-.975-.208-1.504-.345-1.857a3.1 3.1 0 0 0-.748-1.15 3.1 3.1 0 0 0-1.15-.748c-.352-.136-.881-.3-1.856-.344-.95-.043-1.3-.056-3.308-.058M11.999 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 1.755a3.246 3.246 0 1 0 0 6.491 3.246 3.246 0 0 0 0-6.491m5.417-3.422a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
      })
    ], -1)
  ]))]))
}
export default { render: render }